export default {
  'apiUrl': 'https://ky-dev.wecandevelopit.com',
  'version': '/api/v1',
  'defaultLang': 'en',
  'appName': 'Kol-Yom Admin'
}



// WEBPACK FOOTER //
// ./src/settings.js